import { Injectable } from '@angular/core';
import { RenderCanvas, ConfigurateurData, ConfigurateurFacade, Constantes, RenderModele, RenderDefault } from "app/model/configurateur";

@Injectable()
export class ModeleService {
   
    constructor() { }

    buildDefaultRender(data:ConfigurateurData, defaultFacade: ConfigurateurFacade):RenderCanvas {

          let rubriqueFacade = data.rubriques.filter(r => r.code == Constantes.RUBRIQUE_FACADES)[0];
          rubriqueFacade.itemCode = defaultFacade.code;
          let defautRender = (data.renderDefaults!= null && data.renderDefaults.length > 0 ? data.renderDefaults[0] : null);
          
          return this.selectDefaultRenderCanvas(data, defaultFacade, defautRender);
    }

    selectDefaultRenderCanvas(data:ConfigurateurData, defaultFacade: ConfigurateurFacade, defautRender: RenderDefault):RenderCanvas {

          let renderCanvas = new RenderCanvas();
          renderCanvas.facade = defaultFacade;
          let rubriqueFacade = data.rubriques.filter(r => r.code == Constantes.RUBRIQUE_FACADES)[0];
          rubriqueFacade.itemCode = defaultFacade.code;
          
          // apply default render
          if (defautRender != null) {

            if (defautRender.codeDesign != null && defautRender.codeDesign.length > 0 &&
              defautRender.codeMateriau != null && defautRender.codeMateriau.length > 0 &&
              defautRender.codeModele != null && defautRender.codeModele.length > 0 &&
              defautRender.codeCouleur != null && defautRender.codeCouleur.length > 0)
            {
              let rubriqueDesign = data.rubriques.filter(r => r.code == Constantes.RUBRIQUE_DESIGNS)[0];
              let rubriqueMateriau = data.rubriques.filter(r => r.code == Constantes.RUBRIQUE_MATERIAUX)[0];
              let rubriqueModele = data.rubriques.filter(r => r.code == Constantes.RUBRIQUE_MODELES)[0];
              let rubriqueCouleur = data.rubriques.filter(r => r.code == Constantes.RUBRIQUE_COULEURS)[0];
              


              let im = data.renderModeles.find(m => m.codeDesign == defautRender.codeDesign && 
                m.codeMateriau == defautRender.codeMateriau && 
                m.codeModele == defautRender.codeModele && 
                m.codeCouleur == defautRender.codeCouleur);

              if(im == null) {
                im = data.renderModeles.find(m => m.codeDesign == defautRender.codeDesign && 
                  m.codeMateriau == defautRender.codeMateriau && 
                  m.codeModele == defautRender.codeModele);
              }

              if(im == null) {
                im = data.renderModeles.find(m => m.codeDesign == defautRender.codeDesign && 
                  m.codeMateriau == defautRender.codeMateriau);
              }

              if (im != null) {
                renderCanvas.modele = im;  
              }
              else {

                  renderCanvas.modele = data.renderModeles[0];
                
              }

              rubriqueDesign.itemCode = renderCanvas.modele.codeDesign;
              rubriqueMateriau.itemCode = renderCanvas.modele.codeMateriau;
              rubriqueModele.itemCode = renderCanvas.modele.codeModele;
              rubriqueCouleur.itemCode = renderCanvas.modele.codeCouleur;

            }

            if (defautRender.codePoignee != null) {
              let rubriquePoignee = data.rubriques.filter(r => r.code == Constantes.RUBRIQUE_POIGNEES)[0];
              
              let poigneeWithModele = data.poignees.find(m => m.code == defautRender.codePoignee && m.codeModele == renderCanvas.modele.codeModele);
              renderCanvas.poignee = (poigneeWithModele != null ? poigneeWithModele : data.poignees.find(m => m.code == defautRender.codePoignee));

              rubriquePoignee.itemCode = defautRender.codePoignee;

            }

            if (defautRender.codeVitrage != null) {
              let rubriqueVitrage = data.rubriques.filter(r => r.code == Constantes.RUBRIQUE_VITRAGES)[0];
              
              let vitrageWithModele = data.vitrages.find(v => v.code == defautRender.codeVitrage && v.codeModele == renderCanvas.modele.codeModele);
              renderCanvas.vitrage = (vitrageWithModele != null ? vitrageWithModele : data.vitrages.find(v => v.code == defautRender.codeVitrage));

              rubriqueVitrage.itemCode = defautRender.codeVitrage;

            }

            if (defautRender.codeAccessoire != null) {
              let rubriqueAccessoire = data.rubriques.filter(r => r.code == Constantes.RUBRIQUE_ACCESSOIRES)[0];
              
              let accessoireWithModele = data.accessoires.find(a => a.code == defautRender.codeAccessoire && a.codeModele == renderCanvas.modele.codeModele);
              renderCanvas.accessoire = (accessoireWithModele != null ? accessoireWithModele : data.accessoires.find(a => a.code == defautRender.codeAccessoire));
              
              rubriqueAccessoire.itemCode = defautRender.codeAccessoire;

            }
            else {
              renderCanvas.accessoire = null;
              let rubriqueAccessoire = data.rubriques.filter(r => r.code == Constantes.RUBRIQUE_ACCESSOIRES)[0];
              rubriqueAccessoire.itemCode = '';
            }

          }

          return renderCanvas;
    }

    findRenderDefault(data:ConfigurateurData, currentDesign:string, currentMateriau:string, currentModele:string, currentCouleur:string):RenderDefault {
      
      let itemFound:RenderDefault = data.renderDefaults.find(m => m.codeDesign == currentDesign && 
            m.codeMateriau == currentMateriau && 
            m.codeModele == currentModele && 
            m.codeCouleur == currentCouleur);

      if (itemFound == null) {
        itemFound = data.renderDefaults.find(m => m.codeDesign == currentDesign && 
            m.codeMateriau == currentMateriau && 
            m.codeModele == currentModele);
      }

      if (itemFound == null) {
        itemFound = data.renderDefaults.find(m => m.codeDesign == currentDesign && 
            m.codeMateriau == currentMateriau);
      }

      if(itemFound == null && data.renderDefaults != null && data.renderDefaults.length > 0) {
        itemFound = data.renderDefaults[0];
      }

      return itemFound;
    }

    selectRenderModele(data:ConfigurateurData, currentDesign:string, currentMateriau:string, currentModele:string, currentCouleur:string): RenderModele {

      let rc = null;
      if (currentDesign != null && currentDesign.length > 0 &&
        currentMateriau != null && currentMateriau.length > 0 &&
        currentModele != null && currentModele.length > 0 &&
        currentCouleur != null && currentCouleur.length > 0)
        {
          let itemFound = data.renderModeles.find(m => m.codeDesign == currentDesign && 
            m.codeMateriau == currentMateriau && 
            m.codeModele == currentModele && 
            m.codeCouleur == currentCouleur);

             if (itemFound == null) 
             {
              itemFound = data.renderModeles.find(m => m.codeDesign == currentDesign && 
                m.codeMateriau == currentMateriau && 
                m.codeModele == currentModele);
             }
            
             if (itemFound != null) 
             {
               rc = itemFound;
            //   rc = new RenderModele();
            //   rc.code = itemFound.code;
            //   rc.img = itemFound.img;
            //   rc.name = itemFound.name;
            //   rc.itemType = itemFound.itemType;
            //   rc.codeDesign = itemFound.codeDesign;
            //   rc.codeMateriau = itemFound.codeMateriau;
            //   rc.codeModele = itemFound.codeModele;
            //   rc.codeCouleur = itemFound.codeCouleur;
            }
          }

        return rc;
    }

}


// WEBPACK FOOTER //
// ./src/app/services/modele.service.ts